import React from "react";

const HowCreateImage = () => {
    return <div>כאן יוצגו ההוראות ליצירת תמונה.</div>;
};

export default HowCreateImage;
